// The comparisons family's English words (ADR-034 point 1): only this family edits them. What every
// comparison page shares sits here; a page's own words sit in its own two files.
export const COMPARISONS_WORDS_EN = {
  footerTitle: "Compare",
  home: "Home",
  eyebrow: "Compare",
  columns: {
    approach: "Approach",
    strong: "Where it is strong",
    check: "What to check",
    job: "Same job here",
  },
  source: "Source:",
  checked: "checked {date}",
  questionsTitle: "Questions, answered",
};
